module.exports = __webpack_public_path__ + "0cad007967bccb7bdd3d63f013af76a5.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/ESRB_2013_RP_to_Mature.png
// module id = 127
// module chunks = 0